import React from "react";
import FixaLoading from "../../wrappers/FixaLoading/FixaLoading";
import FixaLoadingBall from "../../wrappers/FixaLoading/FixaLoadingBall";

type FixaLoadingBallProps = {
  text: string;
  size: "small" | "medium" | "large";
  color?: "emphasised" | "primary" | "secondary";
};

const SimpleLoadingBall: React.FC<FixaLoadingBallProps> = ({
  text,
  size = "large",
  color = "emphasised",
}: FixaLoadingBallProps) => {
  return (
    <FixaLoading text={text}>
      <FixaLoadingBall color={color} size={size} />
    </FixaLoading>
  );
};

export { SimpleLoadingBall };
